import Vue from "vue"
import VueRouter from "vue-router"
import DashboardPlugin from "./material-dashboard"

//Auth0
import HighlightJs from "./directives/highlight"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faLink, faUser, faPowerOff } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

// Plugins
import App from "./App.vue"
import routes from "./routes/routes"
import store from "./store"
import VueInputMask from "vue-inputmask"
import VueScrollTo from "vue-scrollto"
import VueDragDrop from "vue-drag-drop"
import vuetify from "./plugins/vuetify"
import axios from "axios"
import Plugin from "./plugins/axios"

// plugin setup
Vue.use(VueRouter)
Vue.use(DashboardPlugin)
Vue.use(VueInputMask.default)
Vue.use(VueScrollTo)
Vue.use(VueDragDrop)
Vue.use(vuetify)
Vue.use(Plugin)
Vue.directive("highlightjs", HighlightJs)

library.add(faLink, faUser, faPowerOff)
Vue.component("font-awesome-icon", FontAwesomeIcon)

// configure router
export const router = new VueRouter({
  mode: "history",
  routes, // short for routes: routes
  linkExactActiveClass: "nav-item active",
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

const loadOrg = async () => {
  const urlParams = new URLSearchParams(window.location.search);
  const domain = urlParams.get('domain');
  try {
    const url = process.env.VUE_APP_URL + "/organisations/domains/" + (domain || window.location.host)
    const response = await axios.get(url)
    localStorage.setItem("currentOrg", JSON.stringify(response.data))
  } catch (e) {
    console.log("error loading org", e)
  }
}

loadOrg()

const validateAccess = route => {
  const isAuthenticated = !!sessionStorage.getItem("token")
  const requiresAuth = route.matched.some(record => record.meta.requiresAuth)
  const requiresAdmin = route.matched.some(record => record.meta.requiresAdmin)

  if (requiresAuth && !isAuthenticated) {
    return false
  }

  if (requiresAdmin && !isAuthenticated) {
    return false
  }

  return true
}

const validateRole = route => {
  const userRole = sessionStorage.getItem("usertype")
  const requiresAuth = route.matched.some(record => record.meta.requiresAuth)

  if (!requiresAuth) return true

  if (!userRole) {
    return false
  }

  const hasCorrectRole = route.matched.some(record => record.meta.roles && record.meta.roles.includes(userRole))
  return hasCorrectRole
}

// Route Guard
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = !!sessionStorage.getItem("token")

  if (to.path === "/login" && !isAuthenticated) {
    return next()
  }

  const canAccess = validateAccess(to)
  const roleValidation = validateRole(to)
  if (canAccess && roleValidation) {
    next()
  } else {
    next({ path: "/login" })
  }
})
export const bus = new Vue()

export default router
/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  vuetify,
  store
})
